import {MarketingProviderProps} from "../types";

/**
 * Implements a convention that will attempt to safely extract content from a data object that may include
 * a locale specific prefix in front of the delivery key.
 *
 * @param {Object} contentData
 * @param {string} deliveryKey
 * @param {string|undefined} locale
 * @returns {Object|undefined} proper content for delivery key and locale supplied
 */
export const extractLocalizedCmsData = (
  contentData: MarketingProviderProps["contentData"] | null | undefined,
  deliveryKey: string | null | undefined,
  locale: string | null | undefined
) => {
  if (!contentData || !deliveryKey) {
    return undefined;
  }

  if (!locale) {
    return (contentData[deliveryKey] || {}).contentItems;
  }

  // transform locale fr_CA => fr-ca, contractual delivery key locale format
  const localeSpecificDeliveryKey = `${locale
    .replace("_", "-")
    .toLowerCase()}/${deliveryKey}`;

  return (
    contentData[localeSpecificDeliveryKey] ||
    contentData[deliveryKey] ||
    {}
  ).contentItems;
};
